import reducer from './reducers';
import * as messagesActions from './actions';
import * as messagesSelectors from './selectors';

export { messagesActions, messagesSelectors };
export default reducer;